import { AxiosInstance } from "axios"
import {
    MeetingServiceOrder,
    ReportDetails,
} from "../../../../company/reports/accounting/meetingService/meetingServiceTypes"

export enum SupportMeetingServiceQuery {
    MEETING_SERVICE_ORDERS_FOR_SUPPORT = "meeting-service-orders-for-support-reports",
}

type MeetingServiceOrdersForSupportParams = Readonly<{
    orderId?: string
    pendingApproval?: boolean
    invoiceStatus?: string
    isBooked?: string
    startBookedDate?: string
    endBookedDate?: string
    startDeliveryDate?: string
    endDeliveryDate?: string
    merchantId?: string
    merchantIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethod?: string
    creditCardLast4?: string
    shopIds?: string
    satelliteIds?: string
    buyerPartyIds?: string
}>

export type MeetingServiceOrdersForSupportResponse = Readonly<{
    reportDetails: ReportDetails
    orders: MeetingServiceOrder[]
}>

export async function fetchMeetingServiceOrdersForSupport(
    params: MeetingServiceOrdersForSupportParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MeetingServiceOrdersForSupportResponse> {
    const url = "/accounting/meetingService/orders"

    const { data } = await axios.get(url, {
        params,
        signal,
    })

    return data
}
